import React from "react";
import { motion } from "framer-motion";

/**
 * Reveal — animated wrapper that fades + slides in when scrolled into view.
 * Usage:  <Reveal delay={0.1}> ... </Reveal>
 */
export default function Reveal({
  children,
  delay = 0,
  y = 28,
  duration = 0.8,
  className = "",
  once = true,
  amount = 0.2,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration,
        delay,
        ease: [0.2, 0.6, 0.2, 1],
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

/** Stagger container — children should use `RevealItem` */
export const RevealStagger = ({
  children,
  className = "",
  stagger = 0.08,
  once = true,
}) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount: 0.15 }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "", y = 28 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: [0.2, 0.6, 0.2, 1] },
      },
    }}
    className={className}
  >
    {children}
  </motion.div>
);
